import { Component, Input, OnInit } from '@angular/core';
import { SearchResult } from '../../api/models/search-result';
import { SearchFacetValue } from '../../api/models/search-facet-value';
import { SearchEventPublisher } from '../../shared/service/search-event-publisher.service';
import { SearchEventTypeEnum } from '../../shared/model/search-event-type-enum';
import { Subject } from 'rxjs';
import { AnalyticsService } from 'src/app/shared/service/analytics/analytics.service';
import { FacetDataHolderService } from '../../shared/service/facet-data-holder.service';
import { FacetData } from '../../api/models/facet-data';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@Component({
  selector: 'app-search-primary-navigation',
  templateUrl: './search-primary-navigation.component.html',
  styleUrls: ['./search-primary-navigation.component.scss'],
})
@UntilDestroy()
export class SearchPrimaryNavigationComponent implements OnInit {
  private _searchResult: SearchResult = {};
  facets: Array<SearchFacetValue> = [];
  facetData?: FacetData;
  eventSubject: Subject<boolean> = new Subject<boolean>();
  shouldHide = false;

  constructor(private searchEventPublisher: SearchEventPublisher, private analyticsService: AnalyticsService, private facetDataHolder: FacetDataHolderService) {
  }

  ngOnInit() {
    this.facetDataHolder.getFacetData()
      .pipe(untilDestroyed(this))
      .subscribe(fd => this.facetData = fd);
  }

  get searchResult(): SearchResult {
    return this._searchResult;
  }

  @Input()
  set searchResult(value: SearchResult | undefined) {
    if (value) {
      this._searchResult = value;
      this.initFacets();

      this.shouldHide = !value.searchResultList?.length;
    }
  }

  initFacets() {
    if (this._searchResult?.categoryFacet?.rootNodeWithChildren?.data) {
      this.facets = [];
      this.facets?.push(this._searchResult?.categoryFacet?.rootNodeWithChildren?.data);

      if (this._searchResult?.categoryFacet?.rootNodeWithChildren?.children) {
        this._searchResult?.categoryFacet?.rootNodeWithChildren?.children.forEach(element => {
          this.facets?.push(element.data);
        });
      }
    }
    /*if (this._searchResult.lastSelectedCategoryFacetCode) {
      this.facets.forEach(facet => {
        facet.selected = facet.code === this._searchResult.lastSelectedCategoryFacetCode;
      });
    } else {
      this.facets.forEach(facet => facet.selected = false);
      this.facets[0].selected = true;
    }*/
  }

  selectFacet(selectedFacet: SearchFacetValue) {
    this.facets.forEach(facet => {
      facet.selected = selectedFacet === facet;
    });
    this.searchEventPublisher.publishEvent(SearchEventTypeEnum.NAVIGATE_FACET, selectedFacet?.params);
    this.analyticsService.trackNavigationChange(selectedFacet.params.sn, this.facetData?.facetCodeNameMap, this.facetData?.facetValueCodeNameMap, selectedFacet.englishDisplayString);
  }

  onMouseEnter() {
    this.eventSubject.next(true);
  }

  onMouseLeave() {
    this.eventSubject.next(false);
  }
}
